// This file is auto-generated. Do not edit manually.
import TemplateApp from '@templates/morningstar/App';

export function getTemplateComponent() {
  console.debug(`Template loaded: morningstar`);
  return TemplateApp;
}

export default TemplateApp;
